var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"type_datepicker"},[_c('flat-pickr',{class:this.class,attrs:{"placeholder":_vm.attribute.placeholder,"id":_vm.attribute.id,"disabled":this.disabled,"config":_vm.attribute.config}}),_c('label',{staticClass:"far fa-calendar-alt text_large",attrs:{"for":_vm.attribute.id,"title":_vm.attribute.title}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a246e66","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/IcAnsDatePicker/IcAnsDatePicker.vue
// module id = 571
// module chunks = 0